import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";

const componentRef = React.createRef();
var QRCode = require("qrcode.react");

class Certificado extends React.Component {
  constructor(props){
    super(props);
    this.state ={
        linea: "________________________________________________________"
    };
  }

   //<Licencia modalLicencia=this.state.modalLicencia working=this.state.working licencia=this.state.licencia date=this.state.date/>
  render() {
    return (
      <Modal isOpen={this.props.modalLicencia} modalClassName="modal-message">
        <ModalHeader >
          <div>
            Certificado N° {this.props.producto.no_registro}
            <button type="button"  class="close"  onClick={this.props.change} style={{position: 'fixed', right: '21%'}}>
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className={this.props.working ? "" : "hide"}>
            <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
              CARGANDO INFORMACIÓN
            </div>
          </div>

          <div className={this.props.working ? "hide" : ""}>
            <div
              className="row"
              ref={componentRef}
              style={{ background: "white" }}
            >
              {/*Aqui se muestra licencia******************************************************/}

              <form
                style={{
                  marginRight: "13%",
                  marginLeft: "13%",
                  color: "black",
                }}
              >
                <div style={{ textAlign: "left", margin: "3%" ,}} >
                  <table style={{ width: "100%", tableLayout:"auto" }}>
                    <tbody>
                      <colgroup>
                        <col style={{ width: "50%" }}></col>
                        <col style={{ width: "50%" }}></col>
                      </colgroup>
                      <tr>
                        <td style={{ textAlign: "left", color:"black"}}>
                          <img
                            src="../assets/Escudo.jpg"
                            width="100"
                            height="100"
                          />
                        </td>
                        <td style={{ textAlign: "right", color:"black"}}>
                          <img
                            src="../assets/1631027847767_Logo IPSA.png"
                            width="200"
                            height="100"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="75%">
                        <h5 style={{ textAlign: "right" }}>
                          INSTITUTO DE PROTECCION Y SANIDAD PECUARIOS IPSA
                        </h5>
                        </td>
                        <td width="25%">
                          <div style={{ textAlign: "right",margin: "8%",color: "black",}}>
                            <QRCode
                              size="100"
                              value={
                                "id: " +
                                this.props.producto.id +
                                "\n" +
                                "guid: " +
                                this.props.producto.guid +
                                "\n" +
                                "fecha de vencimiento:" +
                                this.props.producto.vigencia_registro
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                <h5 style={{ textAlign: "center", margin: "8%" }}>
                  CERTIFICADO DE REGISTRO SANITARIO N°{this.props.producto.secuencial}
                </h5>

                <p style={{ textAlign: "justify" }}>
                 El INSTITUTO DE PROTECCIÓN Y SANIDAD AGROPECUARIA, IPSA, a través de la Dirección de Salud Animal, de conformidad
                  con lo establecido en la Legislación Nacional Vigente, <b>CERTIFICA</b> que
                  bajo el No. {this.props.producto.no_registro} se encuentra registrado ante el Departamento de Regulación y 
                  Control de Insumos Pecuarios de esta Dirección, el producto conocido comercialmente como: <b>{this.props.producto.nombre_comercial}</b>
                </p>
                {this.props.solicitud.tipo_producto_veterinario_id === "1"?
                  <div>
                      <p><b>Composición/análisis generalizado</b></p>
                      <p><b>Ingredientes activos:</b> {this.props.activo.map((activo) => (<li>{activo.ingrediente} {activo.concentracion} {activo.unidad_medida}</li>))}</p>
                      <p><b>Excipiente:</b> {this.props.excipientes.map((e) => (<li>{e.excipiente} {e.concentracion} {e.unidad_medida}</li>))}</p>
                      <p><b>Indicaciones de uso:</b> {this.props.producto.uso}</p>
                      <p><b>Dosis por especie y vía de administración: </b>{this.props.dosis.map((e) => (<li>Dosis: {e.dosis}, {e.especie}, {e.categoria}</li>))}</p>
                      <p><b>Periodo de retiro/descarte: </b>{this.props.descarte.map((e) => (<li>{e.periodo} {e.tiempo}, {e.especie}</li>))}</p>
                  </div>
                :null}
                {this.props.solicitud.tipo_producto_veterinario_id === "2" ?
                  <div>
                      <p><b>Composición biológica: </b>{this.props.com_biologica.map((e) => (<li>{e.composicion}, {e.titulo}</li>))}</p>
                      <p><b>Composición química: </b>{this.props.com_quimica.map((e) => (<li>{e.composicion}, {e.concentracion} {e.unidad_medida}</li>))}</p>
                      <p><b>Precauciones de uso:</b> {this.props.producto.precauciones_uso}</p>
                      <p><b>Dosis por especie y vía de administración: </b>{this.props.dosis.map((e) => (<li>{e.dosis}, {e.especie}, {e.categoria}</li>))}</p>
                      <p><b>Periodo de retiro/descarte: </b>{this.props.descarte.map((e) => (<li>{e.periodo} {e.tiempo}, {e.especie}</li>))}</p>
                  </div>
                :null}
                {this.props.solicitud.tipo_producto_veterinario_id === "3" ?
                  <div>
                      <p><b>Ingredientes activos:</b> {this.props.activo.map((activo) => (<li>{activo.ingrediente} {activo.concentracion} {activo.unidad_medida}</li>))}</p>
                      <p><b>Excipiente:</b> {this.props.excipientes.map((e) => (<li>{e.excipiente} {e.concentracion} {e.unidad_medida}</li>))}</p>
                      <p><b>Indicaciones de uso:</b> {this.props.producto.uso}</p>
                      <p><b>Modo de empleo: </b>{this.props.dosis.map((e) => (<li>{e.dosis}, {e.especie}, {e.categoria}</li>))}</p>
                  </div>
                :null}
                {this.props.solicitud.tipo_producto_veterinario_id === "4" ?
                  <div>
                      <p><b>Componentes:</b> {this.props.componente.map((componente) => (<li>{componente.componente}, {componente.concentracion}</li>))}</p>
                      <p><b>Especies de interés:</b> {this.props.especie.map((especie) => (<li>{especie.especie_interes}</li>))}</p>
                      <p><b>Indicaciones de uso:</b> {this.props.producto.uso}</p>
                  </div>
                :null}
                {this.props.solicitud.tipo_producto_veterinario_id === "5" ?
                  <div>
                      <p><b>Análisis garantizado:</b> {this.props.analisis.map((analisis) => (<li>{analisis.analisis} {analisis.porcentaje}%</li>))}</p>
                      <p><b>Indicaciones de uso:</b> {this.props.producto.uso}</p>
                      <p><b>Dosis por especie y vía de administración: </b>{this.props.dosis.map((e) => (<li>{e.dosis}, {e.especie}, {e.categoria}</li>))}</p>
                      <p><b>Periodo de retiro/descarte: </b> {this.props.descarte.map((e) => (<li>{e.periodo} {e.tiempo}, {e.especie}</li>))}</p>
                  </div>
                :null}

                <p><b>Titular del Registro: </b>{this.props.producto.titular}</p>
                <p><b>Fabricante: </b>{this.props.producto.fabricante}</p>
                <p><b>País de Origen: </b>{this.props.producto.pais}</p>
                <p>
                    El registro sanitario de este producto tiene vigencia de {this.props.solicitud.fecha_solicitud} al {this.props.solicitud.fecha_vecimiento} siempre y
                      cuando se encuentre en cumplimiento  de la Legislación Nacional Vigente en la República de Nicaragua.
                </p>

                <p><b>Managua, Nicaragua</b>{" "} {this.props.date}</p>
              
                <p style={{ textAlign: "center", margin: "8%", marginTop:"15em" }}>
                <center>
                   <div style={{borderBottom:"1px solid #333",width:"50%"}}></div>
                   <div>{this.props.solicitud.nombre_firma}</div>
                   </center> Director de Salud Animal</p>
                {/*<p style={{ textAlign: "center", margin: "8%", marginTop:"15em" }}>{this.state.linea}<br></br> Jefe Departamento Regulación y Control de Insumos Precuarios </p>*/}
              </form>
            </div>
            <hr />
          </div>
        </ModalBody>
        <ModalFooter>
          <ReactToPrint
            content={() => componentRef.current}
            pageStyle=""
            trigger={() => (
              <button id="btn-imprimir"  className="btn btn-primary m-r-5">Imprimir</button>
            )}
            onBeforeGetContent={()=>
              this.props.imprimir(this.props.id_detalleP_notificar)}
            />
          <button
            className="btn btn-danger"
            onClick={this.props.change}
          >
            Regresar
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default Certificado;